import api from '../../api';

export const reportService = {
    // Get student report details
    getStudentReport: async (studentId) => {
        try {
            const response = await api.get(`/reports/students/${studentId}`);
            return response.data;
        } catch (error) {
            console.error('Error fetching student report:', error);
            throw error;
        }
    },

    // Get course report details 
    getCourseReport: async (courseId) => {
        try {
            const response = await api.get(`/reports/courses/${courseId}`);
            return response.data;
        } catch (error) {
            console.error('Error fetching course report:', error);
            throw error;
        }
    },

    // Get period report details
    getPeriodReport: async (periodId) => {
        try {
            const response = await api.get(`/reports/periods/${periodId}`);
            return response.data;
        } catch (error) {
            console.error('Error fetching period report:', error);
            throw error;
        }
    },

    // Get quiz report details
    getQuizReport: async (quizId) => {
        try {
            const response = await api.get(`/reports/quizzes/${quizId}`);
            return response.data;
        } catch (error) {
            console.error('Error fetching quiz report:', error);
            throw error;
        }
    },

    // Get overall teacher reports
    getTeacherReports: async () => {
        try {
            const response = await api.get('/reports/teacher');
            return response.data;
        } catch (error) {
            console.error('Error fetching teacher reports:', error);
            throw error;
        }
    },

    // Get competency reports
    getCompetencyReports: async () => {
        try {
            const response = await api.get('/reports/competency');
            return response.data;
        } catch (error) {
            console.error('Error fetching competency reports:', error);
            throw error;
        }
    }
};

export default reportService;
